/*
* Intervention Selection Constants
*
* Weights, intervention types, rules, scopes, and thresholds,
* used to determine the probability and appilicability of an intervention
* in different situations.
*
*/

export const scopeType = {
  word: 'word',
  phrase: 'phrase',
};

export const interventionType = {
  clap: 'clap',
  lipsync: 'lipsync',
  phonemeLipsync: 'phonemeLipsync',
  rhyme: 'rhyme',
  sayit: 'sayit',
  spellout: 'spellout',
  spelloutBefore: 'spelloutBefore',
  phonemeGiveWord: 'phonemeGiveWord',
  giveword: 'giveword',
  read: 'read',
  none: 'none',
  toofast: 'toofast',
  repeatsentence: 'repeatsentence',
  simpledefinition: 'simpledefinition',
  skip: 'skip',
  readwithme: 'readwithme',
  initiateReadWithMe: "initiateReadWithMe",
  endReadWithMe: "endReadWithMe",
  tense: 'tense',
  funfact: 'funfact',
  sight: 'sight',
  comprehension: 'comprehension',
  riddle: 'riddle',
  morpheme: 'morpheme',
  cognate: 'cognate',
  vocabularyWithPictures: 'vocabularyWithPictures',
  prediction: 'prediction',
  letterFlies: 'letterFlies',
  sayASound: 'sayASound',
  soundSeeker: 'soundSeeker',
  name1: 'name1',
  name2: 'name2',
  soundout1: 'soundout1',
  soundout2: 'soundout2',
  soundout3: 'soundout3',
  elkoninBox0: 'elkoninBox0',
  elkoninBox1: 'elkoninBox1',
  elkoninBox2: 'elkoninBox2',
  elkoninBox3: 'elkoninBox3',
  elkoninBox4: 'elkoninBox4',
  upAndDown1: 'upAndDown1',
  upAndDown2: 'upAndDown2',
  upAndDown3: 'upAndDown3',
  wordDisplay: 'wordDisplay',
  changeOnePart1: 'changeOnePart1',
  giveAndTake1: 'giveAndTake1',
  rhyming1: 'rhyming1',
  rhymingQuiz1: 'rhymingQuiz1',
  sayOneSound1: 'sayOneSound1',
  wordInvestigator1: 'wordInvestigator1',
  wordInvestigator2: 'wordInvestigator2',
  wordScramble1: 'wordScramble1',
  GSF: 'GSF',
  msylSegment: 'msylSegment',
};

// In this context, "scope" refers to whether the intervention
// should be played by the interventionManager, which takes care of
// word level interventions
// TODO use phrase and word scope arrays and check for membership
export const interventionTriggerScopes = {
  clap: scopeType.phrase,
  lipsync: scopeType.word,
  rhyme: scopeType.word,
  sayit: scopeType.word,
  spellout: scopeType.word,
  read: scopeType.phrase,
  none: scopeType.word,
  toofast: scopeType.phrase,
  repeatsentence: scopeType.phrase,
  simpledefinition: scopeType.word,
  skip:scopeType.word,
  readwithme: scopeType.phrase,
  initiateReadWithMe: scopeType.phrase,
  endReadWithMe: scopeType.phrase,
  funfact: scopeType.word,
  cognate: scopeType.word,
  tense: scopeType.word,
  sight: scopeType.word,
  decoding: scopeType.word,
  giveword: scopeType.word,
  comprehension: scopeType.phrase,
  riddle: scopeType.word,
  morpheme: scopeType.word,
  name: scopeType.word,
  vocabularyWithPictures: scopeType.word,
  prediction: scopeType.phrase,
  letterFlies: scopeType.word,
  sayASound: scopeType.word,
  soundSeeker: scopeType.word,
  name1: scopeType.word,
  name2: scopeType.word,
  soundout1: scopeType.word,
  soundout2: scopeType.word,
  soundout3: scopeType.word,
  elkoninBox0: scopeType.word,
  elkoninBox1: scopeType.word,
  elkoninBox2: scopeType.word,
  elkoninBox3: scopeType.word,
  elkoninBox4: scopeType.word,
  upAndDown1: scopeType.word,
  upAndDown2: scopeType.word,
  upAndDown3: scopeType.word,
  wordDisplay: scopeType.word,
};

export const rules = {
  minErrorsForHighErrorWeightTable: 3,
  percentageErrorsForHighErrorWeightTable: .333,
  maxWordInterventionsInStory: 12,
  maxWordInterventionsInPhrase: 1,
  maxWordInterventionsInWindow: 2,
  maxPhraseInterventionsInStory: 7,
  maxReadAloudInterventionsInStory: 6,
  maxReadInterventionsInStory: 3,
  maxRepeatSentenceInterventionsInStory: 3,
  accuracyForGoodGambits: 0.75,
  pageInterventionFrequency: 0.3333,
  maxPageGambitsPerStory: 1,
};

export const interventionFrequencyLevels = {
  STANDARD: {
    frustrationCurveSteepness: 1,
    frustrationThreshold: 3,
  },
  HIGH: {
    frustrationCurveSteepness: 1,
    frustrationThreshold: 500,
  },
  LOW: {
    frustrationCurveSteepness: 0.8,
    frustrationThreshold: -0.8,
  },
}